<template>
    <!-- eslint-disable vue/no-v-html -->
    <div
        :id="id.length > 0 ? id : null"
        class="top-banner"
    >
        <a
            v-if="url.length > 0"
            :href="url"
            :target="openinnewwindow ? '_blank' : '_self'"
            class="top-banner__url"
            v-html="text"
        ></a>
        <div
            v-else
            v-html="text"
        ></div>
    </div>
</template>

<script setup>
defineProps({
    id: {
        type: String,
        required: false,
        default: '',
    },

    text: {
        type: String,
        required: true,
    },

    url: {
        type: String,
        required: false,
        default: '',
    },

    openinnewwindow: {
        type: Boolean,
        required: false,
        default: true,
    },
});
</script>

<style scoped lang="scss">
@use "top-banner";
</style>
